import type { ReactInstance, ReactNode } from 'react';
import { createContext, useContext, useRef, useState } from 'react';

interface PageContextType {
  componentRef: React.RefObject<ReactInstance>;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
}

const PageContext = createContext<PageContextType | undefined>(undefined);

interface PageProviderProps {
  children: ReactNode;
}

export function PageProvider({ children }: PageProviderProps) {
  const componentRef = useRef<ReactInstance>(null);
  const [currentPage, setCurrentPage] = useState(0);

  const value = {
    componentRef,
    currentPage,
    setCurrentPage,
  };

  return <PageContext.Provider value={value}>{children}</PageContext.Provider>;
}

export function usePageContext() {
  const context = useContext(PageContext);
  if (context === undefined) {
    throw new Error('usePageContext must be used within a PageProvider');
  }
  return context;
}
